import React from "react";

export type TFileExportIconProps = React.SVGAttributes<SVGElement>;

export function FileExportIcon({ ...rest }: TFileExportIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <mask
        id="fileExportMask"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#fileExportMask)">
        <path
          d="M5.0499 22.375L3.6499 20.95L6.5999 18H4.3499V16H9.9999V21.65H7.9999V19.425L5.0499 22.375ZM11.9999 22V20H17.9999V9H12.9999V4H5.9999V14H3.9999V4C3.9999 3.45 4.19574 2.97917 4.5874 2.5875C4.97907 2.19583 5.4499 2 5.9999 2H13.9999L19.9999 8V20C19.9999 20.55 19.8041 21.0208 19.4124 21.4125C19.0207 21.8042 18.5499 22 17.9999 22H11.9999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
